import {
  resourceReducer,
} from 'redux-resource';

import {
  includedResources,
} from 'redux-resource-plugins';
import {
  allListPlugin,
  multiListPlugin,
} from './plugins';

export default resourceReducer('exerciseResults', {
  plugins: [
    allListPlugin,
    includedResources,
    multiListPlugin,
  ],
});
